<template>
  <basic-container>
    <avue-crud :option="option" v-model="form" :data="data" ref="crud" :page.sync="page" @refresh-change="onLoad"
      @on-load="onLoad">
    </avue-crud>
  </basic-container>
</template>

<script>
// import { getSmartDevicePage } from '@/api/nursingHome/elderDevice';
import {
  getPageListApi
} from '../api/mandateManage';
export default {
  props: {
    row: {
      default: {},
    }
  },
  data() {
    return {
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '咨询人姓名',
            prop: 'name',
          },
          {
            label: '咨询日期',
            prop: 'consultDate',
          },
          {
            label: '联系电话',
            prop: 'tel',
          },
          {
            label: '老人',
            prop: 'elderlyName',
          },
          {
            label: '老人身份证号',
            prop: 'elderlyIdCard',
          },
          {
            label: '咨询方式',
            prop: 'consultType',
          },
          {
            label: '媒体渠道',
            prop: 'channel',
          },
          {
            label: '状态',
            prop: 'status',
          },
          {
            label: '接待人',
            prop: 'reception',
          },
          {
            label: '登记人',
            prop: 'registrant',
          },
        ],
      },
      data: []
    };
  },

  methods: {
    onLoad() {
      // this.loading = true;
      // getPageListApi(
      //   Object.assign(
      //     {},
      //     { current: this.page.currentPage, size: this.page.pageSize, nursinghomeId: this.row.nursinghomeId, elderlyId: this.row.id }
      //   )
      // )
      //   .then(({ data }) => {
      //     this.data = data.records;
      //     this.page.total = data.total;
      //     this.loading = false;
      //   })
      //   .catch(() => {
      //     this.loading = false;
      //   });
    },
  }
};
</script>

<style></style>
